import { jsx, jsxs } from 'react/jsx-runtime';
import React__default from 'react';
import AppleSignin from 'react-apple-signin-auth';
import clsx from 'clsx';
import { ButtonBase } from '../ButtonBase/ButtonBase.js';
import { Image } from '../Image/Image.js';
import { Text } from '../Text/Text.js';

function AppleLoginComponent({
  redirectURI,
  callback,
  iconOnly
}) {
  function handleCallback(res) {
    if (res.error && res.error === 'popup_closed_by_user') return;
    callback(res);
  }
  return jsx(AppleSignin, {
    authOptions: {
      clientId: 'com.belong.consumer.web',
      scope: 'email name',
      redirectURI: redirectURI,
      usePopup: true
    },
    onSuccess: handleCallback,
    onError: handleCallback,
    render: props => jsx(ButtonBase, {
      className: "h-button w-full rounded border border-solid border-navy transition-all duration-hover hover:ring-1 hover:ring-inset hover:ring-navy focus:ring-1 focus:ring-inset focus:ring-navy active:ring-1 active:ring-inset active:ring-navy disabled:text-gray",
      onClick: props.onClick,
      children: jsxs("div", {
        className: clsx('flex w-full items-center', iconOnly ? 'justify-center' : 'justify-start'),
        children: [jsx("div", {
          className: clsx('h-lg w-lg shrink-0', iconOnly ? 'ml-0' : 'ml-sm'),
          children: jsx(Image, {
            src: "/icons/apple_logo.svg",
            alt: ""
          })
        }), !iconOnly && jsx("div", {
          className: "mr-sm w-full",
          children: jsx(Text, {
            fontWeight: "semibold",
            children: "Sign In With Apple"
          })
        })]
      })
    })
  });
}
class AppleLogin extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(_error) {
    return {
      hasError: true
    };
  }
  render() {
    if (!this.state.hasError) return jsx(AppleLoginComponent, {
      ...this.props
    });
  }
}

export { AppleLogin };
